<template>
<div class="complete">
  <div>
    <div v-html="phoneSMSText"></div>
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Complete',
  computed: {
    ...mapState([
      'phoneSMSText',
    ]),
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.complete {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;
  margin-bottom: 3rem;
}

@media (min-width: $breakpoint-tablet) {
  .complete {
    justify-content: flex-start;
  }
}
</style>
